<template>
  <div class="sg-close-button">
    <router-link :id="'tooltip_' + key" tag="span" class="cursor-pointer" :to="{ name: route }">
      <font-awesome-icon icon="times"/>

      <b-tooltip :target="'tooltip_' + key" placement="bottom">
        {{ text }}
      </b-tooltip>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ButtonClose',
  props: ['route', 'text'],
  data () {
    return {
      key: null
    }
  },
  mounted: function () {
    this.key = this.getRandomArbitrary(1, 100)
  },
  methods: {
    getRandomArbitrary: function (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    }
  }
}
</script>

<style scoped>
  .sg-close-button {
    position: absolute;
  }
  @media screen and (max-width: 575px) {
    .sg-close-button {
      top: 5%;
      right: 8%;
    }
  }
  @media screen and (min-width: 576px) {
    .sg-close-button {
      top: 3%;
      right: 5%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/templates/ButtonClose/ButtonClose.vue